import { computed, ref } from "@vue/composition-api";

type ValidateFunction = () => Promise<any>;

export function formValidator() {
  const form = ref<any>(null);
  const validate = computed(() =>
    form.value ? (form.value.validate as ValidateFunction) : null,
  );
  return { validate, form };
}
